export type WorkspaceAgentComposerRunLockedState = {
  activeRunId: string | null;
  isAwaitingRunStart: boolean;
  isCancelling: boolean;
  isSending: boolean;
};

export const isWorkspaceAgentComposerRunLocked = ({
  activeRunId,
  isAwaitingRunStart,
  isCancelling,
  isSending,
}: WorkspaceAgentComposerRunLockedState): boolean =>
  isSending || activeRunId !== null || isAwaitingRunStart || isCancelling;
